/**
 * @fileoverview Utilities for validating logo text input data
 *
 * This module provides functions for validating logo text form data, specifically:
 * - Validating logo title and description fields
 * - Validating CTA and provider logo selections
 *
 * @module Logo
 */

import { ErrorConstants, StateConstants } from 'src/constants';
import { LogoTextState } from 'src/types';

/**
 * Validation errors for logo text input
 */
export interface LogoTextValidationErrors {
  logoTitle?: string;
  logoDescription?: string;
  cta?: string;
  providerLogo?: string;
}

/**
 * Validates logo text input state
 *
 * @param logoTextState - The logo text state to validate
 * @returns Object containing validation errors, empty if all valid
 */
export const validateLogoTextState = (logoTextState: LogoTextState): LogoTextValidationErrors => {
  const errors: LogoTextValidationErrors = {};

  const trimmedTitle = logoTextState.logoTitle?.trim();
  const trimmedDescription = logoTextState.logoDescription?.trim();

  if (trimmedTitle === StateConstants.EMPTY_STRING || !trimmedTitle) {
    errors.logoTitle = ErrorConstants.MESSAGES.LOGO_TITLE_EMPTY;
  }

  if (trimmedDescription === StateConstants.EMPTY_STRING || !trimmedDescription) {
    errors.logoDescription = ErrorConstants.MESSAGES.LOGO_DESCRIPTION_EMPTY;
  }

  if (!logoTextState.cta) {
    errors.cta = ErrorConstants.MESSAGES.CTA_REQUIRED;
  }

  if (!logoTextState.providerLogo) {
    errors.providerLogo = ErrorConstants.MESSAGES.PROVIDER_LOGO_REQUIRED;
  }

  return errors;
};
